






























































import Vue, { PropType } from "vue"
import PTitle from "./local/PTitle.vue"
import PFeature from "./local/PFeature.vue"
import PDetail from "./local/PDetail.vue"
import PDetailWhenNotLoggedIn from "./local/PDetailWhenNotLoggedIn.vue"
import PCorporationInformation from "./local/PCorporationInformation.vue"
import PLayout from "./local/PLayout.vue"
import PShareLinkMenuTag from "./local/PShareLinkMenuTag.vue"
import PHeader from "./local/PHeader.vue"
import {
  ProjectView,
  decorateProjectView,
} from "~/backendApis/viewModel/projectSearch"
import { projectDecorator } from "~/backendApis/viewModel/decorator/projectDecorator"

export default Vue.extend({
  components: {
    PTitle,
    PFeature,
    PDetail,
    PDetailWhenNotLoggedIn,
    PCorporationInformation,
    PLayout,
    PShareLinkMenuTag,
    PHeader,
  },
  props: {
    project: {
      type: Object as PropType<ProjectView>,
      required: true,
    },
    isReadableRequireAuthenticationResources: {
      type: Boolean,
      required: true,
    },
    isFreeAppliableProject: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    corporationProfileUrl(): string {
      return `/corporation/profiles/${this.project.universalCorporationId}`
    },
    isClosedApplication(): boolean {
      return decorateProjectView(this.project).isClosedApplication()
    },
    corporationLogoImageUrl(): string {
      return this.project.corporationLogoImage
        ? this.$clHelpers.thumbnail.generateURL({
            image: this.project.corporationLogoImage,
            width: 50,
            height: 50,
          })
        : ""
    },
    isNewProject(): boolean {
      return projectDecorator(this.project).isNew
    },
  },
  methods: {
    handleClickSignupButton() {
      this.$emit("click-signup-button")
    },
    handleClickLoginButton() {
      this.$emit("click-login-button")
    },
    getMonthDate(project: ProjectView): string {
      return decorateProjectView(project).getMonthDate()
    },
    getPublishedLimitDate(project: ProjectView): string {
      return decorateProjectView(project).getPublishedLimitDate()
    },
    getPublishedEndDate(project: ProjectView): string {
      return decorateProjectView(project).getPublishedEndDate()
    },
    getHeaderImageLargeJobCategoryId(project: ProjectView): number {
      return decorateProjectView(project).getHeaderImageLargeJobCategoryId()
    },
    getHeaderImagePatternNo(project: ProjectView): number {
      return decorateProjectView(project).getHeaderImagePatternNo()
    },
  },
})
